import { Pill } from "src/components/ui/Pill";
import { ChangeManagementImpactLevel } from "src/types/change-management";
import { getImpactDisplay } from "./change-management-plan";

const impactClassName = {
  low: "border-green-500 bg-green-100 text-green-700",
  medium: "border-yellow-500 bg-yellow-100 text-yellow-800",
  high: "border-red-600 bg-red-100 text-red-800",
  unknown: "border-gray-300 bg-gray-100 text-black/60",
};

export const ImpactPill = ({
  level,
}: {
  level: ChangeManagementImpactLevel;
}) => {
  const { label, description } = getImpactDisplay(level);
  return (
    <Pill
      className={impactClassName[level ?? "unknown"]}
      description={description}
    >
      {label}
    </Pill>
  );
};
